import { ThemePreset } from '../types';

export const themePresets: ThemePreset[] = [
  {
    id: 'emerald',
    name: 'เขียวมรกต (Emerald Green)',
    primaryColor: 'bg-emerald-600 border-emerald-600 text-white',
    primaryHover: 'hover:bg-emerald-700',
    accentBg: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    badgeBg: 'bg-emerald-500 text-white',
    textColor: 'text-emerald-700',
    glowShadow: 'shadow-emerald-100',
    hex: '#059669', // Emerald 600
  },
  {
    id: 'forest',
    name: 'เขียวเข้ม (Forest Green)',
    primaryColor: 'bg-green-700 border-green-700 text-white',
    primaryHover: 'hover:bg-green-850',
    accentBg: 'bg-green-50 text-green-800 border-green-200',
    badgeBg: 'bg-green-700 text-white',
    textColor: 'text-green-800 font-medium',
    glowShadow: 'shadow-green-100',
    hex: '#15803d', // Green 700
  },
  {
    id: 'ocean',
    name: 'ฟ้าทะเล (Ocean Blue)',
    primaryColor: 'bg-sky-600 border-sky-600 text-white',
    primaryHover: 'hover:bg-sky-700',
    accentBg: 'bg-sky-50 text-sky-700 border-sky-100',
    badgeBg: 'bg-sky-500 text-white',
    textColor: 'text-sky-700',
    glowShadow: 'shadow-sky-100',
    hex: '#0284c7', // Sky 600
  },
  {
    id: 'navy',
    name: 'น้ำเงินกรมท่า (Navy Blue)',
    primaryColor: 'bg-blue-900 border-blue-900 text-white',
    primaryHover: 'hover:bg-blue-950',
    accentBg: 'bg-blue-50 text-blue-900 border-blue-200',
    badgeBg: 'bg-blue-900 text-white',
    textColor: 'text-blue-900 font-medium',
    glowShadow: 'shadow-blue-200/50',
    hex: '#1e3a8a', // Blue 900
  },
  {
    id: 'indigo',
    name: 'ครามน้ำเงิน (Indigo Modern)',
    primaryColor: 'bg-indigo-600 border-indigo-600 text-white',
    primaryHover: 'hover:bg-indigo-700',
    accentBg: 'bg-indigo-50 text-indigo-700 border-indigo-150',
    badgeBg: 'bg-indigo-600 text-white',
    textColor: 'text-indigo-700 font-semibold',
    glowShadow: 'shadow-indigo-100',
    hex: '#4f46e5', // Indigo 600
  },
  {
    id: 'purple',
    name: 'ม่วงโมเดิร์น (Modern Purple)',
    primaryColor: 'bg-purple-600 border-purple-600 text-white',
    primaryHover: 'hover:bg-purple-700',
    accentBg: 'bg-purple-50 text-purple-700 border-purple-100',
    badgeBg: 'bg-purple-500 text-white',
    textColor: 'text-purple-700',
    glowShadow: 'shadow-purple-100',
    hex: '#9333ea', // Purple 600
  },
  {
    id: 'pink',
    name: 'ชมพูกุหลาบ (Rose Pink)',
    primaryColor: 'bg-rose-500 border-rose-500 text-white',
    primaryHover: 'hover:bg-rose-600',
    accentBg: 'bg-rose-50 text-rose-700 border-rose-100',
    badgeBg: 'bg-rose-500 text-white',
    textColor: 'text-rose-700',
    glowShadow: 'shadow-rose-100',
    hex: '#f43f5e', // Rose 500
  },
  {
    id: 'crimson',
    name: 'แดงเข้ม (Crimson Red)',
    primaryColor: 'bg-red-650 border-red-650 text-white',
    primaryHover: 'hover:bg-red-700',
    accentBg: 'bg-red-50 text-red-700 border-red-100',
    badgeBg: 'bg-red-600 text-white',
    textColor: 'text-red-700 font-semibold',
    glowShadow: 'shadow-red-100',
    hex: '#dc2626', // Red 600
  },
  {
    id: 'orange',
    name: 'ส้มอิฐ (Coral Orange)',
    primaryColor: 'bg-orange-500 border-orange-500 text-white',
    primaryHover: 'hover:bg-orange-600',
    accentBg: 'bg-orange-50 text-orange-850 border-orange-100',
    badgeBg: 'bg-orange-500 text-white',
    textColor: 'text-orange-700 font-semibold',
    glowShadow: 'shadow-orange-100',
    hex: '#f97316', // Orange 500
  },
  {
    id: 'gold',
    name: 'เหลืองทองคลาสสิก (Luxury Gold)',
    primaryColor: 'bg-amber-600 border-amber-600 text-white',
    primaryHover: 'hover:bg-amber-700',
    accentBg: 'bg-amber-50 text-amber-800 border-amber-200',
    badgeBg: 'bg-amber-500 text-white',
    textColor: 'text-amber-800 font-medium',
    glowShadow: 'shadow-amber-100',
    hex: '#d97706', // Amber 600
  },
  {
    id: 'slate',
    name: 'เทาดำเข้ม (Slate Gray)',
    primaryColor: 'bg-slate-600 border-slate-600 text-white',
    primaryHover: 'hover:bg-slate-700',
    accentBg: 'bg-slate-50 text-slate-700 border-slate-100',
    badgeBg: 'bg-slate-500 text-white',
    textColor: 'text-slate-700',
    glowShadow: 'shadow-slate-100',
    hex: '#475569', // Slate 600
  },
  {
    id: 'black',
    name: 'ดำมินิมอล (Minimal Black)',
    primaryColor: 'bg-zinc-800 border-zinc-800 text-white',
    primaryHover: 'hover:bg-zinc-900',
    accentBg: 'bg-zinc-50 text-zinc-800 border-zinc-200',
    badgeBg: 'bg-zinc-800 text-white',
    textColor: 'text-zinc-800',
    glowShadow: 'shadow-zinc-200',
    hex: '#27272a', // Zinc 800
  },
];
